export default function shouldNotifyExtraAttacksReady(previousSubStatus) {
  return previousSubStatus != 'Awaiting Extra Attacks'
}
